import React from 'react';
import './review-form.css';

import Axios from 'axios'
import { baseUrl } from '../assets/Animations';


const ReviewForm = (props) => {

    const [school, setSchool] = React.useState('')
    const [instrument, setInstrument] = React.useState('')
    const [logo, setLogo] = React.useState('')
    const [hoverText, setHoverText] = React.useState(0)
    const [selectedRating, setSelectedRating] = React.useState(0)
    const [reviewText, setReviewText] = React.useState('')
    const [nameText, setNameText] = React.useState('')
    const [weGotIt, setWeGotIt] = React.useState(false)
    const [submitting, setSubmitting] = React.useState(false)

    const urlArray = props.location.pathname.split('/')

    React.useEffect(() => {
        if(urlArray[2] === 'mma') {
            setSchool('Mountainside Music Academy')
            setLogo('/mmalogo.png')
        } else if (urlArray[2] === 'lsma') {
            setSchool('Lakeside Music Academy')
            setLogo('/lakesidelogo.png')
        } else if (urlArray[2] === 'tsma') {
            setSchool('Treeside Music Academy')
            setLogo('/treesidelogo.png')
        } else if (urlArray[2] === 'glma') {
            setSchool('Great Lakes Music Academy')
            setLogo('/greatlakeslogo.png')
        }
        setInstrument(urlArray[3])
    }, [])

    const fillInStars = (star) => {
        if(selectedRating === 0) {
            if (star === 1) {setHoverText('Poor')}
            else if (star === 2) {setHoverText('OK')}
            else if (star === 3) {setHoverText('Average')}
            else if (star === 4) {setHoverText('Good')}
            else if (star === 5) {setHoverText('Excellent')}
            for(let i = 0; i < star; i++) {
                document.getElementById(`star-${i}`).style.fill = '#FBBC00'
            }
        }
    }
    const clearYellowStars = () => {
        if(selectedRating === 0) {
            setHoverText(0)
            for(let i = 0; i < 5; i++) {
                document.getElementById(`star-${i}`).style.fill = 'rgb(200, 200, 200)'
            }
        }
    }

    const chooseARating = (star) => {
        for(let i = 0; i < 5; i++) {
            document.getElementById(`star-${i}`).style.fill = 'rgb(200, 200, 200)'
        }
        if (star === 1) {setHoverText('Poor')}
        else if (star === 2) {setHoverText('OK')}
        else if (star === 3) {setHoverText('Average')}
        else if (star === 4) {setHoverText('Good')}
        else if (star === 5) {setHoverText('Excellent')}
        for(let i = 0; i < star; i++) {
            document.getElementById(`star-${i}`).style.fill = '#FBBC00'
        }
        setSelectedRating(star)
    }

    const sendInReview = () => {
        setSubmitting(true)
        Axios.post(`${baseUrl}/submitreview`, {
            name: nameText,
            rating: selectedRating,
            school: urlArray[2],
            instrument: instrument,
            description: reviewText
        })
        .then((res) => {
            setWeGotIt(true)
            setSubmitting(false)
            setNameText('')
            setSelectedRating(0)
            setReviewText('')
            setHoverText(0)
        })
        .catch((err) => {
            console.log(err)
        })
    }

    return(
        <div className="review-form__wrapper">
            {
                weGotIt && 
                <div className="we-got-it-wrapper">
                    <div className="we-got-it">
                        <div>
                            <img src={logo} className="review-form-logo" />
                            <div>Thank you so much!</div>
                            <div>These reviews are very helpful for us.</div>
                        </div>
                        <div className="we-got-it-btn-wrapper">
                            <div className="new-student-form-btn first-card-btn" onClick={() => setWeGotIt(false)}>close</div>
                        </div>
                    </div>
                </div>
            }
            <div className="review-form__box">
                <img src={logo} className="review-form-logo" />
                <div className="review-form__text">How would you rate your overall experience with {school}?</div>
                <div className="rating-text">{hoverText === 0 ? 'Select a rating' : hoverText}</div>
                <div className="star-box">
                    <svg className="each-star">
                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" onMouseEnter={() => fillInStars(1)} onMouseLeave={() => clearYellowStars()} onClick={() => chooseARating(1)}>
                            <g id="star-0" transform="translate(-385.000000, -931.000000)" fill="rgb(200, 200, 200)">
                                <polygon id="Star-Copy" points="401.5 953.839042 391.801543 960.84878 395.471213 949.458872 385.807567 942.40122 397.774005 942.371608 401.5 931 405.225995 942.371608 417.192433 942.40122 407.528787 949.458872 411.198457 960.84878"></polygon>
                            </g>
                        </g>
                    </svg>
                    <svg className="each-star">
                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" onMouseEnter={() => fillInStars(2)} onMouseLeave={() => clearYellowStars()} onClick={() => chooseARating(2)}>
                            <g id="star-1" transform="translate(-385.000000, -931.000000)" fill="rgb(200, 200, 200)">
                                <polygon id="Star-Copy" points="401.5 953.839042 391.801543 960.84878 395.471213 949.458872 385.807567 942.40122 397.774005 942.371608 401.5 931 405.225995 942.371608 417.192433 942.40122 407.528787 949.458872 411.198457 960.84878"></polygon>
                            </g>
                        </g>
                    </svg>
                    <svg className="each-star">
                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" onMouseEnter={() => fillInStars(3)} onMouseLeave={() => clearYellowStars()} onClick={() => chooseARating(3)}>
                            <g id="star-2" transform="translate(-385.000000, -931.000000)" fill="rgb(200, 200, 200)">
                                <polygon id="Star-Copy" points="401.5 953.839042 391.801543 960.84878 395.471213 949.458872 385.807567 942.40122 397.774005 942.371608 401.5 931 405.225995 942.371608 417.192433 942.40122 407.528787 949.458872 411.198457 960.84878"></polygon>
                            </g>
                        </g>
                    </svg>
                    <svg className="each-star">
                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" onMouseEnter={() => fillInStars(4)} onMouseLeave={() => clearYellowStars()} onClick={() => chooseARating(4)}>
                            <g id="star-3" transform="translate(-385.000000, -931.000000)" fill="rgb(200, 200, 200)">
                                <polygon id="Star-Copy" points="401.5 953.839042 391.801543 960.84878 395.471213 949.458872 385.807567 942.40122 397.774005 942.371608 401.5 931 405.225995 942.371608 417.192433 942.40122 407.528787 949.458872 411.198457 960.84878"></polygon>
                            </g>
                        </g>
                    </svg>
                    <svg className="each-star">
                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" onMouseEnter={() => fillInStars(5)} onMouseLeave={() => clearYellowStars()} onClick={() => chooseARating(5)}>
                            <g id="star-4" transform="translate(-385.000000, -931.000000)" fill="rgb(200, 200, 200)">
                                <polygon id="Star-Copy" points="401.5 953.839042 391.801543 960.84878 395.471213 949.458872 385.807567 942.40122 397.774005 942.371608 401.5 931 405.225995 942.371608 417.192433 942.40122 407.528787 949.458872 411.198457 960.84878"></polygon>
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
            {
            selectedRating 
            ? 
                <div className="review-form__box">
                    <div className="review-form__text">What did you like about {school}?</div>
                    <textarea placeholder="Write about your experience" value={reviewText} onChange={(e) => setReviewText(e.target.value)} />
                    <div className="review-form__text">What's your name?</div>
                    <input placeholder="First and last name" value={nameText} onChange={(e) => setNameText(e.target.value)} />
                    {submitting ?
                    <div className="review-form__submitting-button">submitting</div> :
                    <div className="review-form__submit-button" onClick={() => sendInReview()}>Submit</div>
                    }
                </div>
            :
                null
            }
        </div>
    )
}
export default ReviewForm